module.exports = __webpack_public_path__ + "img/compare-5.f092c435.jpg";